// modules/dashboard/components/SeccionRBC.js
import GraficoBarras from "./GraficoBarras";
import { KpiRow, Tarjeta, Grilla, Subtitulo, EstadoVacio, EncabezadoSeccion, Proporcion, pct } from "./Piezas";
import { ESTRATEGIA_COLOR, AZUL_INSTITUCIONAL } from "../utils/colores";

export default function SeccionRBC({ datos }) {
  const d = datos;
  const acento = ESTRATEGIA_COLOR.rbc;

  return (
    <section id="rbc" className="db-seccion" aria-labelledby="rbc-titulo">
      <EncabezadoSeccion
        id="rbc" emoji="♿" titulo="Discapacidad — RBC" total={d.total} acento={acento}
        descripcion="Rehabilitación Basada en Comunidad: caracterización de personas con discapacidad y sus condiciones de vida."
      />

      {d.total === 0 ? (
        <EstadoVacio emoji="♿" texto="Ningún registro de RBC con los filtros actuales." />
      ) : (
        <>
          <KpiRow acento={acento} items={[
            { valor: d.edadPromedio, unidad: "años", etiqueta: `Edad promedio (${d.edadMin}–${d.edadMax} años)` },
            { valor: `${pct(d.sexo["Femenino"] || 0, d.total)}%`, etiqueta: `Mujeres · ${pct(d.sexo["Masculino"] || 0, d.total)}% hombres` },
            { valor: `${pct(d.certificado["Sí"] || 0, d.total)}%`, etiqueta: "Con certificado de discapacidad (RLCPCD)" },
            { valor: `${pct(d.requiereCuidado["Sí"] || 0, d.total)}%`, etiqueta: "Requiere ayuda para el cuidado" },
            { valor: `${pct(d.asisteEducacion["Sí"] || 0, d.total)}%`, etiqueta: "Asiste actualmente a educación" },
          ]} />

          <Subtitulo>Perfil y territorio</Subtitulo>
          <Grilla>
            <Tarjeta titulo="Personas por comunidad" ancho={7}><GraficoBarras datos={d.comunidad} color={acento} topN={12} /></Tarjeta>
            <Tarjeta titulo="Sexo" ancho={5}>
              <Proporcion datos={d.sexo} destacar="Femenino" etiqueta="mujeres" colores={{ Femenino: acento, Masculino: AZUL_INSTITUCIONAL }} />
              <div style={{ marginTop: 22 }}>
                <h3 style={{ fontSize: "0.9rem", fontWeight: 700, margin: "0 0 10px" }}>Pertenencia étnica</h3>
                <GraficoBarras datos={d.culturaIndigena} color={acento} topN={6} />
              </div>
            </Tarjeta>
            <Tarjeta titulo="EPS / EAPB" ancho={12}><GraficoBarras datos={d.eps} color={acento} horizontal={false} alto={200} topN={10} /></Tarjeta>
          </Grilla>

          <Subtitulo>Tipo de discapacidad</Subtitulo>
          <Grilla>
            <Tarjeta titulo="Categorías de discapacidad" nota="Una persona puede tener varias" ancho={6}><GraficoBarras datos={d.categorias} color={acento} /></Tarjeta>
            <Tarjeta titulo="Dificultades diarias más frecuentes" nota="Selección múltiple" ancho={6}><GraficoBarras datos={d.dificultades} color={acento} /></Tarjeta>
          </Grilla>

          <Subtitulo>Educación, trabajo y cuidado</Subtitulo>
          <Grilla>
            <Tarjeta titulo="Sabe leer" ancho={4}><Proporcion datos={d.sabeLeer} destacar="Sí" acento={acento} etiqueta="sabe leer" /></Tarjeta>
            <Tarjeta titulo="Asiste a educación" ancho={4}><Proporcion datos={d.asisteEducacion} destacar="Sí" acento={acento} etiqueta="asiste" /></Tarjeta>
            <Tarjeta titulo="Trabaja actualmente" ancho={4}><Proporcion datos={d.trabajando} destacar="Sí" acento={acento} etiqueta="trabaja" /></Tarjeta>
            <Tarjeta titulo="Certificado de discapacidad" ancho={4}><Proporcion datos={d.certificado} destacar="Sí" acento={acento} etiqueta="con certificado" /></Tarjeta>
            <Tarjeta titulo="Requiere ayuda para el cuidado" ancho={4}><Proporcion datos={d.requiereCuidado} destacar="Sí" acento={acento} etiqueta="requiere ayuda" /></Tarjeta>
            <Tarjeta titulo="Utiliza pañales" ancho={4}><Proporcion datos={d.utilizaPaniales} destacar="Sí" acento={acento} etiqueta="utiliza" /></Tarjeta>
          </Grilla>

          <Subtitulo>Gestión</Subtitulo>
          <Grilla>
            <Tarjeta titulo="Registros por gestor/a" ancho={12}><GraficoBarras datos={d.gestor} color={AZUL_INSTITUCIONAL} /></Tarjeta>
          </Grilla>
        </>
      )}
    </section>
  );
}
